import useMap from "../../utils/useMap";
import useWeakMap from "../../utils/useWeakMap";
import { isLayer } from "../chain/validator/useLayerIdentity";

const store = useWeakMap();

window['storeOnChanged'] = store

const ALL_PROPS = "*";


const createDepsIfNotExist = (source, keyDep) => {
    if (!store.has(source)) {
        store.set(source, useMap());
    }
    const item = store.get(source);
    if (!item.has(keyDep)) {
        item.set(keyDep, new Set());
    }
}

const addItem = (source, cb, keyDeps) => {
    if (keyDeps === ALL_PROPS) {
        createDepsIfNotExist(source, ALL_PROPS);
        store.get(source).get(ALL_PROPS).add(cb);
    } else if (Array.isArray(keyDeps)) {
        for (let i in keyDeps) {
            const k = keyDeps[i];
            createDepsIfNotExist(source, k);
            store.get(source).get(k).add(cb);
        }
    }
}


const deleteItem = (source, cb, keyDeps) => {
    if (!store.has(layer)) {
        return
    }
    if (keyDeps === ALL_PROPS) {
        store.get(source).get(ALL_PROPS).delete(cb);
    } else if (Array.isArray(keyDeps)) {
        for (let i in keyDeps) {
            const k = keyDeps[i];
            store.get(source).get(k).delete(cb);
        }
    }
}


const useOnOriginalSourceChanged = (originalSource, cb, keyDeps) => {
    if (!keyDeps) throw 'keyDeps not allow null'
    if (isLayer(originalSource)) throw 'Not allow layer';
    if (typeof cb !== 'function') throw 'cb must be function'

    // store.get(originalSource).add(cb);

    if (keyDeps !== ALL_PROPS && !Array.isArray(keyDeps)) {
        return () => { };

    } else if (keyDeps.length === 0) {
        return () => { };
    }

    addItem(originalSource, cb, keyDeps);

    // useDiscard(layer, () => {
    //     deleteItem(originalSource, cb, keyDeps)
    // })

    return () => deleteItem(originalSource, cb, keyDeps)

    // return () => store.get(originalSource).delete(cb);
}

/**
 * 
 * @param {object} originalSource 
 * @param {PropArray} propPaths 
 */
export const emitOriginalSourceChanged = (originalSource, propPaths, absKey, key, value) => {
    if (isLayer(originalSource)) throw 'Not allow layer';
    if (!store.has(originalSource)) return;
    const item = store.get(originalSource);
    if (item.has(absKey)) {
        item.get(absKey).forEach((cb) => {
            cb(propPaths, absKey, key, value)
        })
    }
    if (item.has(ALL_PROPS)) {
        item.get(ALL_PROPS).forEach((cb) => {
            cb(propPaths, absKey, key, value)
        })
    }
    // store.get(originalSource).forEach(cb => {
    //     cb.call(null, originalSource, propPaths, absKey, key, value);
    // })
}

export default useOnOriginalSourceChanged;
